export namespace EFeatureFlags {
  export enum Application {}

  export enum Payments {
    History = "payments:history",
    Reports = "payments:reports",
    FollowUpSMS = "payments:follow_up:sms",
  }
}
